var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2487 48.3344V53.1677H9.66536C6.99599 53.1677 4.83203 51.0037 4.83203 48.3344V9.66768C4.83203 6.99831 6.99599 4.83435 9.66536 4.83435H48.332C51.0014 4.83435 53.1654 6.99831 53.1654 9.66768V33.8344H48.332V9.66768H9.66536V48.3344H36.2487ZM28.9987 17.2341V29.3391C28.2361 29.118 27.4209 28.9996 26.582 28.9996C22.7043 28.9996 19.332 31.5289 19.332 35.0413C19.332 38.5538 22.7043 41.083 26.582 41.083C30.4597 41.083 33.832 38.5538 33.832 35.0413V26.2652L37.3248 28.5938L40.0059 24.5722L28.9987 17.2341ZM41.082 50.751H45.9154V55.5844H50.7487V50.751H55.582V45.9177H50.7487V41.0844H45.9154V45.9177H41.082V50.751ZM28.9982 35.0427C28.9982 35.5343 28.0426 36.251 26.5815 36.251C25.1205 36.251 24.1649 35.5343 24.1649 35.0427C24.1649 34.5511 25.1205 33.8344 26.5815 33.8344C28.0426 33.8344 28.9982 34.5511 28.9982 35.0427Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToLibrary);
export default __webpack_public_path__ + "static/media/add-to-library.b3a6c221.svg";
export { ForwardRef as ReactComponent };